module.exports = __webpack_public_path__ + "static/media/tendericon02@3x.79ac8377.png";